import { AssetsApi, Sprite } from "@worldwidewebb/client-assets";
import { axiosInstance, buildApiClientBasePath } from "..";

const assetsApi = new AssetsApi(undefined, buildApiClientBasePath("assets"), axiosInstance);

export async function getSprites(searchQuery?: string): Promise<Sprite[]> {
  try {
    const { data: sprites } = await assetsApi.getSpritesByQuery(searchQuery);

    return sprites.sort(({ spriteId: a }, { spriteId: b }) => a.localeCompare(b));
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getSprite(spriteId?: string): Promise<Sprite | null> {
  if (spriteId == null) {
    return null;
  }

  try {
    const { data: sprite } = await assetsApi.getSprite(spriteId);

    return sprite;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getSpriteIds(searchQuery?: string): Promise<string[]> {
  try {
    const { data: spriteIds } = await assetsApi.getSpriteIdsByQuery(searchQuery);

    return spriteIds.sort((a, b) => a.localeCompare(b)) as string[];
  } catch (error) {
    console.error(error);
    throw error;
  }
}
